import { StatusIndicator } from '@neo4j-ndl/react';
import type { ActiveDatabase } from '@nx/state';
import { CONNECTION_STATUS, useActiveDatabase, useConnection } from '@nx/state';

const getConnectionStatusType = (
  connection: ReturnType<typeof useConnection>,
  selectedDatabase: ActiveDatabase | undefined,
) => {
  if (selectedDatabase !== undefined && selectedDatabase.currentStatus !== 'online') {
    return 'danger';
  }

  switch (connection.status.value) {
    case CONNECTION_STATUS.CONNECTED:
      return 'success';
    case CONNECTION_STATUS.RECONNECTING:
      return 'warning';
    case CONNECTION_STATUS.CONNECTING:
    case CONNECTION_STATUS.DISCONNECTING:
      return 'info';
    default:
      return 'unknown';
  }
};

export const ConnectionStatusIndicator = () => {
  const connection = useConnection();
  const activeDatabase = useActiveDatabase();

  const connectionStatusType = getConnectionStatusType(connection, activeDatabase);
  const dataTestId = `connection-status-indicator-${connectionStatusType}`;

  return <StatusIndicator data-testid={dataTestId} className="m-0 ml-1" type={connectionStatusType} />;
};
